/// <reference path="BaseField.ts" />

namespace MACRAIL.Forms.Fields {

    export class SingleUpload extends BaseField {
        protected opts: UploadOptions;

        constructor (element: string | JQuery, opts: ObjectHash = {}) {
            super(element, opts);

            let self = this;

            this.element.parents('.btn-file').find(':file').on('fileselect', function(event, numFiles, label) {
                let input = $(this).parents('.input-group').find(':text');

                if (input.length) {
                    input.val(label);
                }
            });
        }

        public getFile() {
            return this.element.prop('files')[0];
        }

        public getValue() {
            let thumbElement = document.getElementById(this.name + '-thumbnail') as HTMLImageElement;

            if (thumbElement) {
                let src = thumbElement.getAttribute("src");

                if (src.length > 42) {
                    return src;
                }

                return null;
            }

            return this.element.prop('files')[0];
        }
    }

    interface UploadOptions extends FieldOptions {

    }

}
